/**
 * useFlowSaveHandler — the Flows-tab Save click. Voluum / Binom: exactly as
 * before (the save runs; a failure is not reported here). Tres Commas: a
 * refused or failed write is shown with the backend's reason (e.g. "flow not
 * in TRES_COMMAS_WRITE_ALLOWED_FLOW_IDS"), so it is never silent.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useCallback } from 'react';
import { matchTracker } from '@trafficpulse/shared';

import { dispatchTracker } from '@/hooks/campaign-tracker';
import type { CampaignProvider } from '@/hooks/voluum/useVoluum';
import { getApiErrorMessage } from '@/lib/api-error';
import { useOptionalToast } from '@/providers/ToastProvider';

export function useFlowSaveHandler(provider: CampaignProvider, saveDraft: () => Promise<void>) {
  const toast = useOptionalToast();
  return useCallback(() => {
    const run = saveDraft();
    matchTracker(dispatchTracker(provider), {
      voluum: () => void run,
      binom: () => void run,
      'tres-commas': () =>
        void run.catch((error: unknown) =>
          toast?.error('Save failed', getApiErrorMessage(error, 'The flow could not be saved.')),
        ),
    });
  }, [provider, saveDraft, toast]);
}
